import React, { memo } from 'react';

import './TabBar.scss';

const TabBar = ({ children, className = '' }) => (
  <div className={`TabBar ${className}`}>{children}</div>
);

export default memo(TabBar);
